import CaseEyes from './CaseEyes.vue';

export default CaseEyes;
